import { withProps, compose } from 'recompose';
import cx from 'classnames';
import { FontTool } from '@nextiva/rich-text-editor';
import withRichTextSelectToolStyles from '../../../hoc/withRichTextSelectToolStyles';

import styles from './FontTextEditorTool.scss';

export default compose(
  withProps({
    className: cx(styles.tool, styles.up),
  }),
  withRichTextSelectToolStyles,
)(FontTool);
